import { cn } from "@/lib/utils";
import trexLogo from "@/assets/trex-head-square-265.png";
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from "@/components/ui/tooltip";

interface AppLogoProps {
    collapsed?: boolean;
    className?: string;
}

export function AppLogo({ collapsed = false, className }: AppLogoProps) {
    return (
        <TooltipProvider>
            <Tooltip>
                <TooltipTrigger asChild>
                    <div
                        className={cn(
                            "flex items-center gap-3 transition-all duration-300 cursor-pointer",
                            className,
                        )}
                    >
                        <img
                            src={trexLogo}
                            alt="Receiptrex"
                            className="h-16 w-16 rounded-xl shrink-0"
                        />
                        <span
                            className={cn(
                                "text-lg font-semibold whitespace-nowrap overflow-hidden transition-all duration-300",
                                collapsed
                                    ? "w-0 opacity-0"
                                    : "w-auto opacity-100",
                            )}
                        >
                            Receiptrex
                        </span>
                    </div>
                </TooltipTrigger>
                <TooltipContent side="right">
                    <p className="font-bold text-lg">GROAAAR!</p>
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
}
